export const SubscribersList = [
    {
        "nomComplet": "Hamadoun Sankaré",
        "adresse": "Golf",
        "email": "hams@yopmail.com",
        "telephone": "+22378694512",
        "typeCarte": "Majeur",
        "structure": "Ministère de la santé",
        "job": "developpeur",
        "Etat": "actif"
    },
    {
        "nomComplet": "Ibrahima KONE",
        "adresse": "Niamana",
        "email": "ib@yopmail.com",
        "telephone": "+22178965412",
        "typeCarte": "Mineur",
        "structure": "Orange Mali",
        "job": "marketer",
        "Etat": "actif"
    },

    {
        "nomComplet": "Paul Diassana",
        "adresse": "Cité Unicef",
        "email": "paul@yopmail.com",
        "telephone": "+22178965412",
        "typeCarte": "Majeur",
        "structure": "Ministère de l'education",
        "job": "enseignant",
        "Etat": "inactif"
    },
    {
        "nomComplet": "Tafsir Maiga",
        "adresse": "Niaman",
        "email": "taf@yopmail.com",
        "telephone": "+223758694512",
        "typeCarte": "Majeur",
        "structure": "Sotelma",
        "job": "ingenieur",
        "Etat": "actif"
    },
    {
        "nomComplet": "Abdoulaye Coulibaly",
        "adresse": "Niamana",
        "email": "ab@yopmail.com",
        "telephone": "+22178698412",
        "typeCarte": "Mineur",
        "structure": "Banque de Développement du Mali",
        "job": "banquier",  
        "Etat": "actif"
    },

    {
        "nomComplet": "Moussa Diarra",
        "adresse": "Cité Unicef",
        "email": "moussa@yopmail.com",
        "telephone": "+2237895422",
        "typeCarte": "Majeur",
        "structure": "Ministère de l'education",
        "job": "enseignant",
        "Etat": "inactif"
    },
] 
